var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentMade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.19,
    height: 21.204,
    viewBox: "0 0 21.19 21.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20630",
    "data-name": "Group 20630",
    transform: "translate(-9227.419 3949.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20654",
    "data-name": "Path 20654",
    d: "M15.323,4.54V15.323H10.7a.77.77,0,0,0-.77.77v4.621H4.54A1.54,1.54,0,0,1,3,19.174V4.54A1.54,1.54,0,0,1,4.54,3h9.242A1.54,1.54,0,0,1,15.323,4.54Z",
    transform: "translate(9225.019 -3951.981)",
    fill: "none",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6453",
    "data-name": "Rectangle 6453",
    width: 13.08,
    height: 7.694,
    rx: 1,
    transform: "translate(9234.929 -3936.671)",
    fill: "none",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_644",
    "data-name": "Ellipse 644",
    cx: 1.539,
    cy: 1.539,
    r: 1.539,
    transform: "translate(9240.314 -3934.362)",
    fill: "none",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1678",
    "data-name": "Line 1678",
    x2: 0.769,
    transform: "translate(9231.082 -3945.903)",
    fill: "none",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1679",
    "data-name": "Line 1679",
    x2: 3.078,
    transform: "translate(9234.159 -3945.903)",
    fill: "none",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1680",
    "data-name": "Line 1680",
    x2: 0.769,
    transform: "translate(9231.082 -3942.826)",
    fill: "none",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1681",
    "data-name": "Line 1681",
    x2: 3.078,
    transform: "translate(9234.159 -3942.826)",
    fill: "none",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1682",
    "data-name": "Line 1682",
    x2: 0.769,
    transform: "translate(9231.082 -3939.748)",
    fill: "none",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1683",
    "data-name": "Line 1683",
    x2: 3.078,
    transform: "translate(9234.159 -3939.748)",
    fill: "none",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMade);
export default __webpack_public_path__ + "static/media/Payment Made.6c9333c2b9432fc4c8ea7c95a6f23b59.svg";
export { ForwardRef as ReactComponent };